/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerDetailsService extends AbstractResourceService<any, any, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('deliveryCustomerDetailsUrl'),
      undefined,
      undefined
    );
  }

  getGeneralInfoForCustomer(customerUuid: string): Observable<JsonApiResource<any, any>> {
    return <Observable<JsonApiResource<any, any>>>this.httpClient?.get(`${this.url}/general/${customerUuid}`, {
      headers: this.headers
    });
  }
}
